import Hero from '@/components/Hero';
import PitchVideoSection from '@/components/PitchVideoSection';
import ReferralCTA from '@/components/ReferralCTA';
import TestimonialSlider from '@/components/ui/testimonial-slider';
import FAQ from '@/components/FAQ';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEOComponent from '@/components/SEOComponent';
import { HomepageWelcomeTour } from '@/components/HomepageWelcomeTour';
import { useAuth } from '@/hooks/useAuth';

const Index = () => {
  const { user } = useAuth();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://www.ai4me.com.br/#webpage",
    "url": "https://www.ai4me.com.br/",
    "name": "AI4ME - Consultoria Empresarial com IA para Micro e Pequenas Empresas",
    "description": "Consultoria empresarial inteligente com IA humanizada 24/7. Gestão, marketing e finanças para empreendedores brasileiros.",
    "isPartOf": { "@id": "https://www.ai4me.com.br/#website" },
    "about": { "@id": "https://www.ai4me.com.br/#organization" },
    "primaryImageOfPage": {
      "@type": "ImageObject",
      "url": "https://www.ai4me.com.br/lovable-uploads/c4f8b3f8-f36b-45d0-95d4-097a69303b76.png"
    },
    "inLanguage": "pt-BR"
  };

  return (
    <>
      <SEOComponent 
        title="AI4ME - Consultoria Empresarial com IA para Micro e Pequenas Empresas | 24/7"
        description="Consultoria empresarial inteligente com IA humanizada 24/7. Especializada em gestão, marketing e finanças para micro e pequenos empreendedores brasileiros. Teste grátis com 30 créditos. A partir de R$ 47,90/mês."
        keywords="consultoria empresarial com IA, inteligência artificial para negócios, consultoria para micro empresa, gestão empresarial, marketing digital IA, finanças PME, MEI, simples nacional, pequeno empreendedor, AI4ME"
        canonical="/"
        ogType="website"
        author="AI4ME Brasil"
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          <Hero />
          <PitchVideoSection />
          <TestimonialSlider />
          <ReferralCTA />
          <FAQ />
          
        </main>
        <Footer />
        {/* Tour para visitantes não logados */}
        {!user && <HomepageWelcomeTour />}
      </div>
    </>
  );
};

export default Index;